// Preloads a fresh copy of the image offscreen and swaps it in only once loaded, so it never flashes blank.
// When reloads overlap, only the newest one lands, so a slow older render can't replace a newer one.
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["image"];
  static values = { url: String };

  busy() {
    this.element.setAttribute("data-reloading", "");
  }

  reload() {
    const rendering = new Image();
    this.latestRendering = rendering;

    rendering.addEventListener("load", () => {
      if (rendering !== this.latestRendering) return;

      this.imageTarget.src = rendering.src;
      this.settle();
      this.dispatch("reloaded");
    });
    rendering.addEventListener("error", () => {
      if (rendering === this.latestRendering) this.settle();
    });

    rendering.src = `${this.urlValue}?v=${Date.now()}`;
  }

  settle() {
    this.element.removeAttribute("data-reloading");
  }
}
